<template>
  <div>
    <Intro />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Intro from '@/components/Intro.vue'
export default {
  name: 'App',
  components: {
    Intro, Footer
  }
}
</script>
